// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import { Button } from 'ui'
import {Alert, Modal} from 'ui'
import QualCodeActions from 'actions/QualCodeActions'
import {FormControl, ControlLabel, FormGroup} from 'ui'

const INITIAL_STATE = {
  currentPassword: "",
  newPassword: "",
  verifyPassword: "",
};

class PasswordModal extends React.Component {
  constructor () {
    super();
    this.state = INITIAL_STATE;

    this.onCurrentPasswordChange = this.onCurrentPasswordChange.bind(this);
    this.onNewPasswordChange = this.onNewPasswordChange.bind(this);
    this.onVerifyPasswordChange = this.onVerifyPasswordChange.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onHide = this.onHide.bind(this);
  }

  componentDidUpdate(prevProps) {
    // Clear form when modal closes successfully
    if (prevProps.passwordState.show && !this.props.passwordState.show && this.props.passwordState.success) {
      this.setState(INITIAL_STATE);
    }
  }

  onCurrentPasswordChange(e)
  {
    this.setState({
      currentPassword: e.target.value
    })
  }

  onSave(e)
  {
      QualCodeActions.changePassword(this.state.currentPassword, this.state.newPassword, this.state.verifyPassword);
  }

  onNewPasswordChange(e)
  {
    this.setState({
      newPassword: e.target.value
    })
  }

  onVerifyPasswordChange(e)
  {
    this.setState({
      verifyPassword: e.target.value
    })
  }

  onHide(e)
  {
    QualCodeActions.showPasswordModal(false);
    this.setState(INITIAL_STATE);
  }

  render () {
    return (
      <div>
        <Modal show={this.props.passwordState.show} onHide={this.onHide}>
            <Modal.Header closeButton>
              <Modal.Title>Change Password</Modal.Title>
            </Modal.Header>

            <Modal.Body>

            {(this.props.passwordState.message && !this.props.passwordState.success) &&
              <Alert variant="danger">
                <p>
                  {this.props.passwordState.message}
                </p>
              </Alert>
              }

              <form>
                <FormGroup controlId="currentPassword">
                  <ControlLabel>Current Password</ControlLabel>
                  <FormControl
                    componentClass="input"
                    type="password"
                    placeholder=""
                    value={this.state.currentPassword}
                    onChange={this.onCurrentPasswordChange}
                  />
                </FormGroup>

                <FormGroup controlId="newPassword">
                  <ControlLabel>New Password</ControlLabel>
                  <FormControl
                    componentClass="input"
                    type="password"
                    placeholder=""
                    value={this.state.newPassword}
                    onChange={this.onNewPasswordChange}
                  />
                </FormGroup>

                <FormGroup controlId="verifyPassword">
                  <ControlLabel>Verify Password</ControlLabel>
                  <FormControl
                    componentClass="input"
                    type="password"
                    placeholder=""
                    value={this.state.verifyPassword}
                    onChange={this.onVerifyPasswordChange}
                  />
                </FormGroup>
              </form>
            </Modal.Body>
          <Modal.Footer>
            <Button variant="blue" onClick={this.onSave}>Save</Button>
          </Modal.Footer>
      </Modal>
      </div>
    );
  }
}

export default PasswordModal;
